import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { capitalize, Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import Table from 'react-bootstrap/Table';
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select"
import { DOCUMENT_URL } from "assets/globalAPI/apiGlobal";
import { saveVendorForm1 } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchKDSVendor } from "assets/globalAPI/apiGlobal";
import { fetchAllVendors } from "assets/globalAPI/apiGlobal";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';


const VendorForm=()=>{
    const navigate= useNavigate();
    const [loaderspinner, setLoaderSpinner] = useState(false);
    const [isMsme, setIsMsme] = useState(false);
    const [isfssi, setIsFssi] = useState(false);
    const [isActive,setIsActive]= useState(false)
    const [stateSelected,setStateSelected]= useState(false)
    const [titleSelected,setTitleSelected]= useState(false)
    const toastId = React.useRef(null);
    const [loader, setLoader] = useState(false);
    const [formSubmitted, setIsFormSubmiteed] = useState(false);
    const [panGSTError, setPanGSTError] = useState(false);
    const [panGSTError2, setPanGSTError2] = useState(false);
    const contactEmail= localStorage.getItem("contactPersonEmail")
    const contactMobile= localStorage.getItem("contactPersonMobile")
    const refId= localStorage.getItem("refId");
    const [selectedState,setSelectedState]= useState("");
    const [selectedTitle,setSelectedTitle]= useState("");
    const [fssaiApplicable,setFssaiApplicable]= useState("Unregistered");
    const [msmeApplicable,setMsmeApplicable]= useState("No");
    const [gstAvailable,setGstAvailable]= useState("Yes")
     const [kdsdata,setKdsData]=useState({});
     const [vendorState,setVendorState]=useState([]);
     const [vendorArr,setVendorArr]= useState([]);
    const [refID, setRefID] = useState(localStorage.getItem("refId") || ""); 
    // console.log("refId>> ", refId)
    const refType= localStorage.getItem("refType")

    const [firmTypes,setFirmTypes]= useState([]);

    const [formValues, setFormValues] = useState({
      reference_id: {value: refID, error: false},
      trade_name: { value: '', error: false }, // Trade Name(as per gst)*
      street: { value: '', error: false }, // Address(to be registered as per GST)*
      house_no: { value: '', error: false }, // House No.
      type_of_firm: { value: '', error: false }, // Type of Firm/Company*
      cin: { value: '', error: false }, // CIN (if applicable)
      mca_roc_status: { value: 'Active', error: false }, // MCA/ROC status (for Co/LLP)
      city: { value: '', error: false }, // City*
      state: { value: '', error: false }, // State*
      pin_code: { value: '', error: false }, // Pin Code*
      website: { value: '', error: false }, // Website
      proprietor_name: { value: '', error: false }, 
      proprietor_email: { value: '' , error: false}, 
      proprietor_mobile: { value: '' , error: false}, 
      pan: { value: '', error: false }, 
      contact_person: { value: '' , error: false}, // Name of Contact Person*
      contact_person_email: { value: contactEmail, error: false }, // Mobile Number*
      contact_person_mobile: { value: contactMobile, error: false },
      contact_telephone: { value: '', error: false },
      // nature_of_business: { value: [],error: false }, // Nature of Business*
      // business_category: { value: [],error: false }, 
      msme_registration_status: { value: 'Unregistered',error: false }, // MSME Registration Status.
      msme_registration_no: { value: '',error: false }, // MSME Registration no.
      msme_category: { value: '',error: false }, // MSME Category
      msme_type: { value: '',error: false }, // MSME Type
      fssai_registration_status: { value: 'Unregistered',error: false }, // FSSI Registration Status.
      fssai_regn_no: { value: '',error: false }, // FSSI Regn No
      fssai_valid_till: { value: '',error: false }, // FSSI Valid Till (dd-mm-yyyy)
      gstn: { value: '',error: false }, // GSTN No*.
      tan: { value: '',error: false }, // TAN*
      itr_filing_status: { value: '',error: false }, // Status of filing ITR of last 2 yrs.
      pan_linked_aadhaar: { value: '',error: false }, // PAN linked with Aadhaar
      gst_turnover_prev_yr: { value: '',error: false }, // GST Turnover of Prev Yr.(Lakhs).
      // prev_yr: { value: '',error: false }, // Prev Yr
      e_invoice_applicable: { value: 'Yes',error: false }, // E-Invoice Applicable
      bank_name: { value: '',error: false }, // Bank Name.
      ifsc_code: { value: '',error: false }, // IFSC Code
      bank_account_number: { value: '',error: false }, // Bank Account Number
      cheque_number: { value: '',error: false }, // Cheque Number
      cheque_issued_name: { value: '',error: false }, 
      date_of_fillup: { value: '',error: false }, // GSTN Document*
      approval_status: {value: 'pending'},
    });

    console.log("global json>> ", formValues)

    useEffect(() => {
      if (refID) {
        setFormValues((prevValues) => ({
          ...prevValues,
          reference_id: { value: refID, error: false },
        }));
        console.log("ref id is>> ", refID)
      }
    }, [refID]);

     useEffect(() => {
      localStorage.setItem("gstAvailable", gstAvailable);
      if (gstAvailable=="No") {
        setFormValues((prevValues) => ({
          ...prevValues,
          gstn: { value: '', error: false },
        }));
        // console.log("ref id is>> ", refID)
      }
    }, [gstAvailable]);

    useEffect(() => {
      localStorage.setItem("mcaAvailable", formValues.mca_roc_status.value=="Active"?"Yes":"No");
     
    }, [formValues.mca_roc_status.value]);

     useEffect(() => {
      if (formValues.msme_registration_status.value=="Unregistered") {
        setMsmeApplicable("No")
        localStorage.setItem("msme",false)
        setFormValues((prevValues) => ({
          ...prevValues,
          msme_registration_no: { value: '', error: false },
          msme_category: { value: '', error: false },
          msme_type: { value: '', error: false },
          // msme_type: { value: '', error: false },
        }));
        // console.log("ref id is>> ", refID)
      }else if(formValues.msme_registration_status.value=="Registered"){
        localStorage.setItem("msme",true)
        setMsmeApplicable("Yes")
      }
    }, [formValues.msme_registration_status.value]);

     useEffect(() => {
      if (formValues.fssai_registration_status.value=="Unregistered") {
        setFssaiApplicable("Unregistered")
        localStorage.setItem("fssi",false)
        setFormValues((prevValues) => ({
          ...prevValues,
          fssai_regn_no: { value: '', error: false },
          fssai_valid_till: { value: '', error: false },
          // msme_type: { value: '', error: false },
          // msme_type: { value: '', error: false },
        }));
        // console.log("ref id is>> ", refID)
      }else if(formValues.fssai_registration_status.value=="Registered"){
        localStorage.setItem("fssi",true)
        setFssaiApplicable("Registered")
      }
    }, [formValues.fssai_registration_status.value]);

 function formatDate(value) {
    if (!value) return '';
  
    // If value is already in YYYYMMDD format
    if (typeof value === 'string' && value.length === 8 && /^\d{8}$/.test(value)) {
      const year = value.substring(0, 4);
      const month = value.substring(4, 6);
      const day = value.substring(6, 8);
      return `${year}-${month}-${day}`;
    }
  
    // If value is in YYYY-MM-DD or similar format
    const dateObj = new Date(value);
  
    // If date is valid, format it
    if (!isNaN(dateObj.getTime())) {
      return dateObj.toISOString().split('T')[0];
    }
  
    // If invalid, don't touch it. Let the user keep typing.
    return value;
  }

    const fetchVendors=async()=>{
        setIsActive(true)
        let body;
        body={
          page:1,
          reference_id: refID
        }
        
        try{
          const response= await fetchAllVendors(body);
          const res= response.data;
          if(res.status){
            console.log("Vendors fetched>> ", res);
            setVendorArr(res.data);
            const updatedValues = {};
    
        Object.keys(formValues).forEach((key) => {
          if (res.data[0].hasOwnProperty(key)) {
            updatedValues[key] = {
              ...formValues[key],
              value: res.data[0][key] || '' // in case it's undefined or null
            };
          } else {
            updatedValues[key] = formValues[key]; // keep original
          }
        });
    
        setFormValues(updatedValues);
        console.log("Filtered and updated form >>>", updatedValues);
            setIsActive(false)
          }else{
            console.log("Could not fetch vendors>> ", res);
            setVendorArr([]);
            setIsActive(false)
          }
        }catch(err){
          console.log("Error bringing vendors>> ", err);
          setIsActive(false)
          if(err.response?.status==403){
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.error(err.response.data.message,{
                className:"small-toast"
              })
            }
            setTimeout(()=>{
              navigate("/")
              localStorage.clear();
            },2000)
          }
        }
      }

      function capitalizeInitials(str) {
        return str
          .split(/(\s+)/) // this keeps the spaces too
          .map(word => {
            return word.trim() ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word;
          })
          .join('');
      }

    useEffect(() => {
      const isAuthenticate= localStorage.getItem("isAuthenticated");
      // if(!isAuthenticate){
      //   navigate("/vendor/validation");
      //   return;
      // }

      
      fetchVendors();
      fetchAllVendorKDS()
      let msme= localStorage.getItem("msme");
      let fssi= localStorage.getItem("fssi");
      setIsMsme(JSON.parse(msme));
      setIsFssi(JSON.parse(fssi));
      let localForm = localStorage.getItem("filledForm2");
      let parsedFrom= JSON.parse(localForm)
      console.log("what is in form>>> ", JSON.parse(localForm))
      if(parsedFrom!==null){
        setFormValues(JSON.parse(localForm))
      }
    },[]);
    

    const handleFormChange = (field, value) => {
      let updatedValue = value;
  
      // Check if the field is one of the multi-selects
      if (field === "nature_of_business" || field === "business_category") {
          // For multi-select fields, we need to extract the 'value' from the selected options array
          updatedValue = value.map(option => option.value);
      }

     
  
      // Update the state for the given field
      setFormValues((prevState) => ({
        ...prevState,
        [field]: {
            ...prevState[field],
            value: updatedValue,
        },
        reference_id: {
            ...prevState.reference_id,
            value: refID || localStorage.getItem("refId") || "", // Ensure refID is always set
        },
        date_of_fillup:{
          ...prevState.date_of_fillup,
          value: new Date().toISOString().split('T')[0].replaceAll("-", ""),
        }
    }));
    
  };

   const fetchAllVendorKDS=async()=>{
            try{
              const response= await fetchKDSVendor();
              const res= response.data;
              if(res.status){
                setKdsData(res.data);
                setFirmTypes(res.data.title)
                setVendorState(res.data.region)
                console.log("kds fetched>> ", res.data);
              }else{
                console.log("could not bring material kds>> ", res)
              }
            }catch(error){
              console.log("error bringing material KDS>> ", error);
            }
          }
  

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    setIsActive(true);

    if(gstAvailable=="Yes"){
      if(formValues.gstn.value==""){
         if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Please Fill GSTIN Number", {
            className: "small-toast"
          });
        }
        setIsActive(false);
        return;
      }
    }

    if(msmeApplicable=="Yes"){
      if(formValues.msme_category.value=="" || formValues.msme_registration_no.value=="" || formValues.msme_registration_status.value=="" || formValues.msme_type.value==""){
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Please Fill All MSME Details", {
            className: "small-toast"
          });
        }
        setIsActive(false);
        return;
      }
    }

    if(fssaiApplicable=="Yes"){
      if(formValues.fssai_registration_status.value==""|| formValues.fssai_regn_no.value==""|| formValues.fssai_valid_till.value==""){
         if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Please Fill All FSSAI Details", {
            className: "small-toast"
          });
        }
        setIsActive(false);
        return;
      }
    }

  
    const requiredFields = [
      "trade_name", "type_of_firm", "city","street", "state","house_no", "pin_code",
      , "proprietor_name", "proprietor_email", "proprietor_mobile", "pan",
      "contact_person", "contact_person_email", "contact_person_mobile",
      "bank_name", "ifsc_code", "bank_account_number","cheque_number", "cheque_issued_name"
    ];

    let missingFieldName=[];

    
  
    let hasError = false;
    let updatedValues = { ...formValues };

    if(msmeApplicable=="Yes"){
      if(formValues.msme_registration_no.value=="UDYAM-"||formValues.msme_registration_no.value==""||formValues.msme_registration_status.value==""|| formValues.msme_category.value=="" || formValues.msme_category.value==""|| formValues.msme_type.value==""){
        console.log("msme not filled")
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Please Fill All The Required MSME Fields", {
            className: "small-toast"
          });
        }
        
        setIsActive(false);
        return;
      }
    }

    if(fssaiApplicable=="Yes"){
      if(formValues.fssai_registration_status.value==""|| formValues.fssai_regn_no.value=="" || formValues.fssai_valid_till.value==""){
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Please Fill All The Required FSSAI Fields", {
            className: "small-toast"
          });
        }
        
        setIsActive(false);
        return;
      }
    }

    // const fieldsToCapitalize = [
    //   "trade_name", "street", "city", "bank_name", 
    //   "cheque_issued_name", "proprietor_name", "contact_person"
    // ];
  
    requiredFields.forEach(key => {
      if (!updatedValues[key]?.value|| (key === "pin_code" && updatedValues[key].value.length < 6)) {
        updatedValues[key] = { ...updatedValues[key], error: true };
        hasError = true;
        missingFieldName.push(key)
      } else {
        updatedValues[key] = { ...updatedValues[key], error: false };
      }
    });

    // fieldsToCapitalize.forEach((key) => {
    //   if (updatedValues[key]?.value) {
    //     updatedValues[key] = {
    //       ...updatedValues[key],
    //       value: capitalizeInitials(updatedValues[key].value)
    //     };
    //   }
    // });
  
    setFormValues(updatedValues); 
  
    if (hasError) {
      console.log("cannot submit, fill mandatory>>> ", missingFieldName)
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Please Fill All The Required Fields", {
          className: "small-toast"
        });
      }
      
      setIsActive(false);
      return;
    }
  
    try {
      setIsFormSubmiteed(true);
      console.log("here is the final form>> ", updatedValues);
      localStorage.setItem("filledForm", JSON.stringify(updatedValues));
      localStorage.setItem("filledForm2", JSON.stringify(updatedValues));
  
      const response = await saveVendorForm1(updatedValues);
      const res = response.data;
      console.log("the response from submit is >> ", res);
  
      if (res.status) {
        console.log("Submitted successfully>> ", res);
        setIsActive(false);
        navigate("/vendor/registration-form-2");
      } else {
        console.log("could not submit>> ", res);
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Could not submit form", {
            className: "small-toast"
          });
        }
        setIsActive(false);
      }
    } catch (err) {
      console.log("Error registering vendor>> ", err);
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Error Submitting Form", {
          className: "small-toast"
        });
      }
      setIsActive(false);
    }
  };
  

    return(
      <>
      <SimpleBackdrop openLoader={isActive} />
      <ToastContainer/>
     <Grid>
      

       <SoftBox py={0} className="customerblock">
       <Grid container spacing={3}>
       <Grid item xs={12} lg={12} className="headerForm">
       
       <SoftBox p={0} display="flex" alignItems="center" justifyContent="space-between">
<img src={anmolLogo} alt="Logo" style={{ height: 100 }} />

<SoftTypography  variant="h3" id="form_heading" style={{ flex: 1, textAlign: "center" }}>
 Vendor Registration
</SoftTypography>

{/* This empty box ensures the text remains centered */}
<div style={{ width: 50 }}></div>
</SoftBox>


       <Grid>
                     {loaderspinner ? <div style={{
                       position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                       zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                     }}>
                       <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                     </div> : ""}
       </Grid>
       
       </Grid>
       </Grid>
       </SoftBox>
        
        <SoftBox className="bp formBG">
          <form noValidate onSubmit={handleSubmitForm}>
         <SoftBox py={3} className="customerblock">
           <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                   <SoftTypography variant="h5" id="form_heading textUppercase">General Data</SoftTypography>

                   

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                       <Grid item xs={12} md={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Name*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="Trade name"
                             id="trade_name"
                             inputProps={{ maxLength: 40 }}
                             error={formValues.trade_name.error} 
                             value={formValues.trade_name.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('trade_name', wordCapital)}}
                             
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} md={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Street*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             name="Address"
                             id="address"
                             inputProps={{ maxLength: 60 }}
                             error={formValues.street.error}
                             value={formValues.street.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('street', wordCapital)}}
                             
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={10} md={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               House Number*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="Address"
                             id="address"
                             inputProps={{ maxLength: 10 }}
                             error={formValues.house_no.error}
                             value={formValues.house_no.value}
                             onChange={(e) => handleFormChange('house_no', e.target.value)}
                             
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} md={3}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Type of Firm/Company*
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
  name="Type of Firm"
  id="type_of_firm"
  error={formValues.type_of_firm.error}
  value={
   [{ value: formValues.type_of_firm.value, label:titleSelected? selectedTitle: formValues.type_of_firm.value }]
  }
  onChange={(e) =>{
    setTitleSelected(true)
    setSelectedTitle(e.label)
    handleFormChange('type_of_firm', e.value)
  }}
  options={firmTypes}
/>

                         </SoftBox>
                       </Grid>
                     </Grid>
                   </SoftBox>

                   <SoftBox mt={1}>
                     <Grid container spacing={3}>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              CIN (if applicable)
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             error={formValues.cin.error}
                             id="cin"
                             value={formValues.cin.value}
                             onChange={(e) => handleFormChange('cin', e.target.value)}
                             size="medium"
                            
                              />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               MCA/ROC Status (for Co/LLP)
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="Mca Status"
                             id="mca_roc_status"
                             error={formValues.mca_roc_status.error}
                             value={[{value: formValues.mca_roc_status.value, label: formValues.mca_roc_status.value}]}
                             onChange={(e) => {handleFormChange('mca_roc_status', e.value)
                              localStorage.setItem("mcaAvailable",e.value=="Active"?"Yes":"No")
                             }}
                             options={[
                               { value: "Active", label: "Active" },
                               { value: "Strike Off", label: "Strike Off" },
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               City*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="city"
                             inputProps={{ maxLength: 40 }}
                             error={formValues.city.error}
                             value={formValues.city.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('city', wordCapital)}}
                             size="medium" />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               State*
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="state"
                             id="state"
                             error={formValues.state.error}
                             value={[{value: formValues.state.value, label: stateSelected? selectedState :formValues.state.value}]}
                             onChange={(e) =>{
                              setStateSelected(true)
                              setSelectedState(e.label)
                              handleFormChange('state', e.value)
                             } }
                              options = {vendorState}
                             
                           />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Pin Code*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="pin_code"
                             inputProps={{ maxLength: 6 }}
                             error={formValues.pin_code.error}
                             value={formValues.pin_code.value}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('pin_code', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                              if(e.target.value.length==6){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Pin Code Cannot be more than 6 characters", {
            className: "small-toast"
          });
        }
                              }
                            }}
                             size="medium"
                              />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Website
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="website"
                             name="website"
                            //  error={formValues.website.error}
                             value={formValues.website.value}
                             onChange={(e) => handleFormChange('website', e.target.value)}
                             size="medium"
                             
                             />
                         </SoftBox>
                       </Grid>
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               CIN (If MCA/ROC is Active)
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput  
                             type="file"
                             disabled={formValues.mca_roc_status.value !== "Active"}
                             value={formValues.latest_co_status.value}
                             onChange={(e) => handleFormChange('latest_co_status', e.target.file)}
                             placeholder="Street"
                             id="street"
                             size="medium" />
                         </SoftBox>
                       </Grid> */}
                     </Grid>
                   </SoftBox>


                 
                   

                   

                 </SoftBox>
               </Card>
             </Grid>
           </Grid>
         </SoftBox>

         <SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     <SoftTypography variant="h5" id="form_heading">Contact Details</SoftTypography>


       <SoftBox mt={1}>
         <Grid container spacing={3}>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Proprietor Name*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="Proprieter Name"
                 id="prop_name"
                 inputProps={{ maxLength: 40 }}
                 error={formValues.proprietor_name.error}
                 value={formValues.proprietor_name.value}
                 onChange={(e) => {
                  let wordCapital= capitalizeInitials(e.target.value)
                  handleFormChange('proprietor_name', wordCapital)}}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Proprietor Email*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="prop email"
                 id="prop_email"
                 error={formValues.proprietor_email.error}
                 value={formValues.proprietor_email.value}
                 onChange={(e) => handleFormChange('proprietor_email', e.target.value)}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Proprietor Mobile No*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="prop number"
                 id="prop_number"
                 inputProps={{ maxLength: 10 }}
                 error={formValues.proprietor_mobile.error}
                 value={formValues.proprietor_mobile.value}
                 onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                  handleFormChange('proprietor_mobile', onlyNumbers);
                }}
                onKeyDown={(e)=>{
                              if(e.target.value.length==10){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
            className: "small-toast"
          });
        }
                              }
                            }}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Contact Person Name*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="contact name"
                 id="contact_person_name"
                 inputProps={{ maxLength: 40 }}
                //  defaultValue={formValues.contact_person}
                 value={formValues.contact_person.value}
                 error={formValues.contact_person.error}
                 onChange={(e) => {
                  let wordCapital= capitalizeInitials(e.target.value)
                  handleFormChange('contact_person', wordCapital)}}
               />
             </SoftBox>
           </Grid>

           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Contact Person Email*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="contact person number"
                 id="contact_person_number"
                //  defaultValue={formValues.contact_person_email}
                 value={formValues.contact_person_email.value}
                 error={formValues.contact_person_email.error}
                 onChange={(e) => handleFormChange('contact_person_email', e.target.value)}
               />
             </SoftBox>
           </Grid>

           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Contact Person Mobile No*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="contact person number"
                 id="contact_person_number"
                 inputProps={{ maxLength: 10 }}
                //  defaultValue={formValues.contact_person_mobile}
                 value={formValues.contact_person_mobile.value}
                 error={formValues.contact_person_mobile.error}
                 onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                  handleFormChange('contact_person_mobile', onlyNumbers);
                }}
                onKeyDown={(e)=>{
                              if(e.target.value.length==10){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Mobile No Cannot be more than 10 digits", {
            className: "small-toast"
          });
        }
                              }
                            }}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Contact Person Telephone
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="contact_telephone"
                 id="contact_telephone"
                 inputProps={{ maxLength: 11 }}
                //  defaultValue={formValues.contact_person_mobile}
                 value={formValues.contact_telephone.value}
                 error={formValues.contact_telephone.error}
                 onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                  handleFormChange('contact_telephone', onlyNumbers);
                }}
                onKeyDown={(e)=>{
                              if(e.target.value.length==11){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Telephone No Cannot be more than 11 digits", {
            className: "small-toast"
          });
        }
                              }
                            }}
               />
             </SoftBox>
           </Grid>

         </Grid>
       </SoftBox>

     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

         <SoftBox py={3} className="customerblock">
           <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                   <SoftTypography variant="h5" id="form_heading">Business Data</SoftTypography>

                   
<Grid container spacing={3} alignItems="center">
 {/* <Grid item xs={12} sm={4}>
   <SoftBox mb={2}>
     <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
       <SoftTypography component="label" variant="caption" fontWeight="bold" >
         Nature of Business*
       </SoftTypography>
     </SoftBox>
     <Select
       isMulti
       name="nature_of_business"
       id="nature_of_business"
       error={formValues.nature_of_business.error}
       // value={formValues.nature_of_business.value}
       onChange={(selectedOptions) => handleFormChange("nature_of_business", selectedOptions)}
       options={[
         { value: "Capital Goods", label: "Capital Goods" },
         { value: "Manufacturing", label: "Manufacturing" },
         { value: "Trading", label: "Trading" },
         { value: "Exporter", label: "Exporter" },
         { value: "Service", label: "Service" },
         { value: "CSR", label: "CSR" },
         { value: "OTPY", label: "OTPY" },
       ]}
       styles={{
         control: (provided) => ({
           ...provided,
           minHeight: "34px",
           fontSize: "9px",
         }),
         multiValue: (provided) => ({
           ...provided,
           fontSize: "10px",
           padding: "2px",
         }),
         placeholder: (provided) => ({
           ...provided,
           fontSize: "12px",
         }),
         dropdownIndicator: (provided) => ({
           ...provided,
           padding: "4px",
         }),
       }}
     />
   </SoftBox>
 </Grid> */}

 {/* <Grid item xs={12} sm={4}>
   <SoftBox mb={2}>
     <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
       <SoftTypography component="label" variant="caption" fontWeight="bold" >
         Business Category
       </SoftTypography>
     </SoftBox>
     <Select
       isMulti
       name="business_category"
       id="business_category"
       error={formValues.business_category.error}
       // value={formvalues.business}
       onChange={(selectedOptions) => handleFormChange("business_category", selectedOptions)}
       options={[
         { value: "Raw Mat", label: "Raw Mat" },
         { value: "Packaging Mat", label: "Packaging Mat" },
         { value: "Engg Store", label: "Engg Store" },
         { value: "Fuel", label: "Fuel" },
         { value: "Transporter", label: "Transporter" },
         { value: "Contractor", label: "Contractor" },
         { value: "Oth Services", label: "Oth Services" },
         { value: "Capital", label: "Capital" },
         { value: "Adv & Sales Prom", label: "Adv & Sales Prom" },
       ]}
       styles={{
         control: (provided) => ({
           ...provided,
           minHeight: "34px",
           fontSize: "9px",
         }),
         multiValue: (provided) => ({
           ...provided,
           fontSize: "10px",
           padding: "2px",
         }),
         placeholder: (provided) => ({
           ...provided,
           fontSize: "12px",
         }),
         dropdownIndicator: (provided) => ({
           ...provided,
           padding: "4px",
         }),
       }}
     />
   </SoftBox>
 </Grid> */}


<>
{/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Are You MSME Registered?
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="msme_applicable"
                             id="msme_applicable"
                            //  error={formValues.fssai_registration_status.error}
                             value={[{value: msmeApplicable, label: msmeApplicable}]}
                             // value={formValues.fssi_registration_status.value}
                             onChange={(e) =>{
                              localStorage.setItem("msme",true)
                              setMsmeApplicable(e.value)
                             } }
                             options={[
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid> */}

                       <Grid item xs={12} sm={4}>
   <SoftBox mb={2}>
     <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
       <SoftTypography component="label" variant="caption" fontWeight="bold" >
         MSME Registration Status.
       </SoftTypography>
     </SoftBox>
     <SoftSelect
                             name="msme_status"
                             id="msme_status"
                             className="formstyle"
                            //  error={formValues.msme_registration_status.error}
                             value={[{value: formValues.msme_registration_status.value, label: formValues.msme_registration_status.value}]}
                             onChange={(e) => {
                              localStorage.setItem("msme",e.value=="Registered"?true:false)
                              setMsmeApplicable(e.value=="Registered"?"Yes":"No");
                              handleFormChange('msme_registration_status', e.value)}}
                             options={[
                               { value: "Registered", label: "Registered" },
                               { value: "Unregistered", label: "Unregistered" },
                             ]}
                           />
   </SoftBox>
                      </Grid>
</>

  

{(isMsme || msmeApplicable==="Yes") &&

                   
                     <>
                   
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
  <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
    <SoftTypography
      component="label"
      variant="caption"
      fontWeight="bold"
    >
      MSME Registration no*.
    </SoftTypography>
  </SoftBox>
  <SoftInput
    name="msme_no"
    id="msme_no"
    className="formstyle"
    inputProps={{ maxLength: 19 }}
    value={
      formValues.msme_registration_no.value.startsWith("UDYAM-")
        ? formValues.msme_registration_no.value
        : "UDYAM-" + formValues.msme_registration_no.value
    }
    error={formValues.msme_registration_no.error}
    type="text"
    onChange={(e) => {
      let input = e.target.value;

      // If user tries to delete or type before the prefix, prevent it
      if (!input.startsWith("UDYAM-")) {
        let pre= "UDYAM-"
        input = "UDYAM-" + input.replace(new RegExp(`^${pre.replace('-', '\\-')}*`), '');
      }

      handleFormChange("msme_registration_no", input);
    }}
  />
</SoftBox>

                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              MSME Category*
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="msme_category"
                             id="msme_category"
                            //  error={formValues.msme_category.error}
                             value={[{value: formValues.msme_category.value, label: formValues.msme_category.value}]}
                             onChange={(e) => handleFormChange('msme_category', e.value)}
                             options={[
                               { value: "Macro", label: "Macro" },
                               { value: "Small", label: "Small" },
                               { value: "Medium", label: "Medium" },
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              MSME Type*
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="msme_type"
                             id="msme_type"
                            //  error={formValues.msme_type.error}
                             value={[{value: formValues.msme_type.value, label: formValues.msme_type.value}]}
                             onChange={(e) => handleFormChange('msme_type', e.value)}
                             options={[
                               { value: "A", label: "A" },
                               { value: "B", label: "B" },
                               { value: "C", label: "C" },
                               { value: "D", label: "D" },
                               { value: "E", label: "E" },
                               { value: "F", label: "F" },
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                      
                     </>
                  

}

<>
<Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              FSSAI Registration Status
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="fssai_applicable"
                             id="fssai_applicable"
                            //  error={formValues.fssai_registration_status.error}
                             value={[{value: fssaiApplicable, label: fssaiApplicable}]}
                             // value={formValues.fssi_registration_status.value}
                             onChange={(e) =>{
                              localStorage.setItem("fssi",e.value=="Registered"?true:false)
                              setFssaiApplicable(e.value)
                              handleFormChange('fssai_registration_status', e.value)
                             } }
                             options={[
                               { value: "Registered", label: "Registered" },
                               { value: "Unregistered", label: "Unregistered" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>
</>
{(isfssi || fssaiApplicable==="Registered")  &&
                   <>
                    
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               FSSAI Registration Status.
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="fssai_status"
                             id="fssai_status"
                            //  error={formValues.fssai_registration_status.error}
                             value={[{value: formValues.fssai_registration_status.value, label: formValues.fssai_registration_status.value}]}
                             // value={formValues.fssi_registration_status.value}
                             onChange={(e) => handleFormChange('fssai_registration_status', e.value)}
                             options={[
                               { value: "Registered", label: "Registered" },
                               { value: "Un-registered", label: "Un-registered" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid> */}
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              FSSAI Regn No*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="fssai_reg"
                             id="fssai_reg"
                             inputProps={{ maxLength: 20 }}
                            //  error={formValues.fssai_regn_no.error}
                             value={formValues.fssai_regn_no.value}
                             onChange={(e) => handleFormChange('fssai_regn_no', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              FSSAI Valid Till*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="date"
                             name="fssai_valid"
                             id="fssai_valid"
                            //  error={formValues.fssai_valid_till.error}
                             value={formatDate(formValues.fssai_valid_till.value)}
                             onChange={(e) => {
                              const dateObj = new Date(e.target.value);
                              const day = String(dateObj.getDate()).padStart(2, '0');
                              const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                              const year = dateObj.getFullYear();
                              const formattedDate = `${year}${month}${day}`;
                              console.log("here is formattedDate>> ", formattedDate)  
                              handleFormChange('fssai_valid_till', formattedDate);
                            }}
                           />
                         </SoftBox>
                       </Grid>

                       
                      
                     
                   </>
}
                   <>
                    <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              GSTIN Available
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="gst_avail"
                             id="gst_avail"
                            //  error={formValues.itr_filing_status.error}
                             // value={formValues.itr_filing_status.value}
                             value={[{value: gstAvailable, label: gstAvailable}]}
                             onChange={(e) => {setGstAvailable(e.value)
                              localStorage.setItem("gstAvailable",e.value);
                             }}
                             options={[
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                              //  { value: "Not Filed", label: "Not Filed" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               GSTIN No {gstAvailable=="Yes" && <span>*</span>}
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="gstn"
                             id="Gstn"
                             inputProps={{maxLength:15}}
                             error={formValues.gstn.error} 
                             value={formValues.gstn.value}
                             onChange={(e) => {
                              const gstn = e.target.value.trim();
                            
                              if (gstn === "") {
                                setPanGSTError2(false)
                                setFormValues((prev) => ({
                                  ...prev,
                                  gstn: { ...prev.gstn, value: gstn, error: false },
                                  pan: { ...prev.pan, value: "", error: false },
                                }));
                                return;
                              }
                            
                              const gstnRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
                            
                              if (gstnRegex.test(gstn)) {
                                const panFromGstn = gstn.substring(2, 12);
                                setFormValues((prev) => ({
                                  ...prev,
                                  gstn: { ...prev.gstn, value: gstn, error: false },
                                  pan: { ...prev.pan, value: panFromGstn, error: false },
                                }));
                                setPanGSTError2(false)
                              } else {
                                if (!toast.isActive(toastId.current)) {
                                  toastId.current = toast.warning("Please Fill a valid GSTIN number", {
                                    className: "small-toast"
                                  });
                                }
                                setPanGSTError2(true)
                                setFormValues((prev) => ({
                                  ...prev,
                                  gstn: { ...prev.gstn, value: gstn, error: true },
                                  pan: { ...prev.pan, value: "", error: false },
                                }));
                              }
                            }}
                            
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              PAN*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="pan"
                             id="pan"
                             inputProps={{maxLength:10}}
                             error={formValues.pan.error}
                             value={formValues.pan.value}
                             onChange={(e) => {
                              const pan = e.target.value.trim().toUpperCase(); // PAN is always uppercase
                              const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                            
                              if (pan === "") {
                                setFormValues((prev) => ({
                                  ...prev,
                                  pan: { ...prev.pan, value: pan, error: false },
                                }));
                                return;
                              }
                            
                              if (panRegex.test(pan)) {
                                setFormValues((prev) => ({
                                  ...prev,
                                  pan: { ...prev.pan, value: pan, error: false },
                                }));
                                setPanGSTError(false)
                              } else {
                                setFormValues((prev) => ({
                                  ...prev,
                                  pan: { ...prev.pan, value: pan, error: true },
                                }));
                            
                                if (!toast.isActive(toastId.current)) {
                                  toastId.current = toast.warning("Please enter a valid PAN number", {
                                    className: "small-toast",
                                  });
                                }
                                setPanGSTError(true)
                              }
                            }}
                            
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              TAN
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tan"
                             id="tan"
                             error={formValues.tan.error}
                             value={formValues.tan.value}
                             onChange={(e) => handleFormChange('tan', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                   </>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Status of filing ITR of last 2 yrs.
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="itr_filing"
                             id="itr_filing"
                             error={formValues.itr_filing_status.error}
                             // value={formValues.itr_filing_status.value}
                             value={[{value: formValues.itr_filing_status.value, label: formValues.itr_filing_status.value}]}
                             onChange={(e) => handleFormChange('itr_filing_status', e.value=="Select"?"":e.value)}
                             options={[
                               { value: "Select", label: "Select" },
                               { value: "Filed", label: "Filed" },
                               { value: "Not Filed", label: "Not Filed" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              PAN linked with Aadhaar
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="pan_linked_aadhaar"
                             id="pan_linked_aadhaar"
                             error={formValues.pan_linked_aadhaar.error}
                             value={[{value: formValues.pan_linked_aadhaar.value, label: formValues.pan_linked_aadhaar.value}]}
                             onChange={(e) => handleFormChange('pan_linked_aadhaar', e.value=="Select"?"":e.value)}
                             options={[
                               { value: "Select", label: "Select" },
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              TDS Exemption/Lower Deduction
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="tds_ememption"
                             id="tds_exemption"
                             error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             options={[
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid> */}
                  
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               If Yes, then please attach TDS Exemption/Lower Deduction Certificate.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="file"
                             id="tds_doc"
                             disabled={formValues.tds_exemption.value !== "Yes"}
                             error={formValues.tds_doc.error}
                             value={formValues.tds_doc.value}
                             onChange={(e) => handleFormChange('tds_doc', e.target.file)}
                           />
                         </SoftBox>
                       </Grid> */}
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Nature of Service for TDS
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_nature"
                             id="td_nature"
                             error={formValues.tds_nature_of_service.error}
                             value={formValues.tds_nature_of_service.value}
                             onChange={(e) => handleFormChange('tds_nature_of_service', e.target.value)}
                           />
                         </SoftBox>
                       </Grid> */}
                       
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              TDS to be Deducted u/s
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_section"
                             id="tds_section"
                             error={formValues.tds_section.error}
                             value={formValues.tds_section.value}
                             onChange={(e) => handleFormChange('tds_section', e.target.value)}
                           />
                         </SoftBox>
                       </Grid> */}

                  
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               GST Turnover of Prev Yr (Lakhs).
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="gst_turnover"
                             error={formValues.gst_turnover_prev_yr.error}
                             value={formValues.gst_turnover_prev_yr.value}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('gst_turnover_prev_yr', onlyNumbers);
                            }}
                            //  onChange={(e) => handleFormChange('gst_turnover_prev_yr', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Prev Yr
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="prev_yr"
                             id="prev_yr"
                             error={formValues.prev_yr.error}
                             value={formValues.prev_yr.value}
                             onChange={(e) => handleFormChange('prev_yr', e.target.value)}
                           />
                         </SoftBox>
                       </Grid> */}
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              e-Invoice Applicable
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="e-invoice"
                             id="e-invoice"
                             value={[{value: formValues.e_invoice_applicable.value, label: formValues.e_invoice_applicable.value}]}
                             error={formValues.e_invoice_applicable.error}
                             onChange={(e) => handleFormChange('e_invoice_applicable', e.value=="Select"? "": e.value)}
                             options={[
                               { value: "Select", label: "Select" },
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>


                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Bank Name*.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             id="bank_name"
                             error={formValues.bank_name.error}
                             value={formValues.bank_name.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('bank_name', wordCapital)}}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              IFSC Code*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="ifsc_code"
                             id="ifsc_code"
                             inputProps={{ maxLength: 20 }}
                             error={formValues.ifsc_code.error}
                             value={formValues.ifsc_code.value}
                             onChange={(e) => handleFormChange('ifsc_code', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Bank Account Number*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="incoterms2"
                             id="incoterms2"
                             inputProps={{maxLength:18}}
                             error={formValues.bank_account_number.error}
                             value={formValues.bank_account_number.value}
                             onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                              handleFormChange('bank_account_number', onlyNumbers);
                            }}
                            onKeyDown={(e)=>{
                              if(e.target.value.length==20){
                                 if (!toast.isActive(toastId.current)) {
          toastId.current = toast.warning("Account No Cannot be more than 20 characters", {
            className: "small-toast"
          });
        }
                              }
                            }}
                           />
                         </SoftBox>
                       </Grid>
                       
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                              Cheque Number*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="incoterms2"
                             id="incoterms2"
                             inputProps={{ maxLength: 20 }}
                             error={formValues.cheque_number.error}
                             value={formValues.cheque_number.value}
                             onChange={(e) => handleFormChange('cheque_number', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>

                  
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               Cheque to be Issued in name of*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="text"
                             size="medium"
                             name="cheque_issued_name"
                             id="cheque_issued_name"
                             inputProps={{ maxLength: 60 }}
                             error={formValues.cheque_issued_name.error}
                             value={formValues.cheque_issued_name.value}
                             onChange={(e) => {
                              let wordCapital= capitalizeInitials(e.target.value)
                              handleFormChange('cheque_issued_name', wordCapital)}}
                             
                           />
                         </SoftBox>
                       </Grid>

                       {/* <Grid item xs={12} sm={4}>
                       <SoftBox mb={3} id="mkcustomer">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               GSTN Document*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="file"
                             size="medium"
                             name="gstn_document"
                             id="gstn_document"
                             error={formValues.gstn_document.error}
                             // value={formValues.gstn_document.value}
                             onChange={(e) => handleFormChange('gstn_document', e.target.file)}
                           />
                       </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               
                             >
                               PAN Document*
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                             type="file"
                             name="pan"
                             id="pan"
                             error={formValues.pan_document.error}
                             value={formValues.pan_document.value}
                             onChange={(e) => handleFormChange('pan_document', e.target.file)}
                             placeholder="GSTN"
                             size="medium"
                             // inputProps={{ maxLength: "15" }}
                           />
                         </SoftBox>
                       </Grid> */}
                    </Grid> 
                 </SoftBox>
               </Card>
             </Grid>
           </Grid>
         </SoftBox>
         <SoftBox py={3} className="customerblock">
<Grid container spacing={3}>
 <Grid item xs={12} lg={12}>
   <Card sx={{ overflow: "visible" }}>
     <SoftBox p={3}>
     {/* <div style={{ display: "flex", gap: "8px", alignItems: "baseline" }}>
<input 
// style={{marginTop:'10px'}}
 type="checkbox" 
 style={{ cursor: "pointer", marginTop:'10px' }} 
 checked={formValues.declaration?.value || false} 
 onChange={(e) => handleFormChange("declaration", e.target.checked)} 
/>
<SoftTypography variant="h5" id="form_heading">
 <span style={{ fontSize: "12px" }}>
   I/W<span style={{textTransform: 'lowercase'}}>e</span> <span style={{textTransform: 'lowercase'}}> certify that the above information given here in including the attachments are correct to the best of my knowledge. </span>
 </span>
</SoftTypography>
</div> */}


       {/* <SoftBox mt={1}>
         <Grid container spacing={3}>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Date*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="date"
                 name="Trade name"
                 id="trade_name"
                 error={formValues.date_of_fillup.error}
                 value={formValues.date_of_fillup.value}
                 onChange={(e) => handleFormChange('date_of_fillup', e.target.value)}
               />
             </SoftBox>
           </Grid>
           <Grid item xs={12} sm={4}>
             <SoftBox mb={3}>
               <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                 <SoftTypography
                   component="label"
                   variant="caption"
                   fontWeight="bold"
                   
                 >
                   Signature (Your Full Name)*
                 </SoftTypography>
               </SoftBox>
               <SoftInput
                 type="text"
                 name="Address"
                 id="address"
                 error={formValues.signature.error}
                 value={formValues.signature.value}
                 onChange={(e) => handleFormChange('signature', e.target.value)}
               />
             </SoftBox>
           </Grid>
         </Grid>
       </SoftBox> */}

       {/* Submit Button */}
       <Grid container justifyContent="flex-end" mt={2}>
         <Grid item>
          {(vendorArr.length == 0 || 
  (vendorArr[0] &&
   (!vendorArr[0].pan_document || vendorArr[0].pan_document === "") &&
   (!vendorArr[0].cancel_cheque_document || vendorArr[0].cancel_cheque_document === ""))) &&

           <SoftButton disabled={panGSTError || panGSTError2} type="submit" variant="contained" color="primary">
             Save & Continue
           </SoftButton>
            
          }
         </Grid>
       </Grid>
       {vendorArr.length > 0 &&
 vendorArr[0] &&
 (
   (vendorArr[0].pan_document && vendorArr[0].pan_document !== "") &&
   (vendorArr[0].cancel_cheque_document && vendorArr[0].cancel_cheque_document !== "")
 )  && (

       <>
       <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
         UPLOADED DOCUMENTS
       </SoftTypography>
       <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
         <tbody>
           <tr>
             <td><strong>GSTIN Document</strong></td>
             <td>{vendorArr[0]?.gstn_document ? (
         <a
           href={`${DOCUMENT_URL}/${vendorArr[0].gstn_document}`}
           target="_blank"
           rel="noopener noreferrer"
           style={{
             fontWeight: "bold",
             color: "#007bff",
             textDecoration: "none",
             display: "flex",
             alignItems: "center",
           }}
         >
           <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
         </a>
       ) : (
         ""
       )}</td>
             <td><strong>PAN Document</strong></td>
             <td>{vendorArr[0]?.pan_document ? (
         <a
           href={`${DOCUMENT_URL}/${vendorArr[0].pan_document}`}
           target="_blank"
           rel="noopener noreferrer"
           style={{
             fontWeight: "bold",
             color: "#007bff",
             textDecoration: "none",
             display: "flex",
             alignItems: "center",
           }}
         >
           <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
         </a>
       ) : (
         ""
       )}</td>
           </tr>
     
           <tr>
             <td><strong>MSME Document</strong></td>
             <td>{vendorArr[0]?.msme_document ? (
         <a
           href={`${DOCUMENT_URL}/${vendorArr[0].msme_document}`}
           target="_blank"
           rel="noopener noreferrer"
           style={{
             fontWeight: "bold",
             color: "#007bff",
             textDecoration: "none",
             display: "flex",
             alignItems: "center",
           }}
         >
           <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
         </a>
       ) : (
         ""
       )}</td>
             <td><strong>FSSAI Document</strong></td>
             <td>{vendorArr[0]?.fssai_document ? (
         <a
           href={`${DOCUMENT_URL}/${vendorArr[0].fssai_document}`}
           target="_blank"
           rel="noopener noreferrer"
           style={{
             fontWeight: "bold",
             color: "#007bff",
             textDecoration: "none",
             display: "flex",
             alignItems: "center",
           }}
         >
           <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
         </a>
       ) : (
         ""
       )}</td>
           </tr>
     
           <tr>
             <td><strong>TDS Document</strong></td>
             <td>{vendorArr[0]?.tds_document ? (
         <a
           href={`${DOCUMENT_URL}/${vendorArr[0].tds_document}`}
           target="_blank"
           rel="noopener noreferrer"
           style={{
             fontWeight: "bold",
             color: "#007bff",
             textDecoration: "none",
             display: "flex",
             alignItems: "center",
           }}
         >
           <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
         </a>
       ) : (
         ""
       )}</td>
             <td><strong>CIN Document</strong></td>
             <td>{vendorArr[0]?.latest_co_status_document ? (
         <a
           href={`${DOCUMENT_URL}/${vendorArr[0].latest_co_status_document}`}
           target="_blank"
           rel="noopener noreferrer"
           style={{
             fontWeight: "bold",
             color: "#007bff",
             textDecoration: "none",
             display: "flex",
             alignItems: "center",
           }}
         >
           <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
         </a>
       ) : (
         ""
       )}</td>
           </tr>
          
         </tbody>
       </Table>
       </>
 )
       }
     </SoftBox>
   </Card>
 </Grid>
</Grid>
</SoftBox>

         </form>
         </SoftBox>
        
     </Grid>
     </>
    )
}

export default VendorForm